import api from "axios";

export const getDealersData = async () => {
  return api
    .get("/dealer")
    .then((response) => response.data.payload)
    .catch((error) => `dealer ${error}`);
};

export const getDealerUfsData = async (url) => {
  return api
    .get(`/dealer/${url}/ufs`)
    .then((response) => response.data.payload)
    .catch((error) => `dealer ufs ${error}`);
};

export const favoriteDealer = async (id) => {
  return api
    .get(`/dealer/favorite/add/${id}`)
    .then((response) => response.data.payload)
    .catch((error) => `dealer favorite ${error}`);
};

export const unFavoriteDealer = async (id) => {
  return api
    .get(`/dealer/favorite/remove/${id}`)
    .then((response) => response.data.payload)
    .catch((error) => `dealer unfavorite ${error}`);
};

export const getRegionsData = async () => {
  return api
    .get("/regions")
    .then((response) => response.data.payload)
    .catch((error) => `regions ${error}`);
};
